import React from 'react';
import {
  Box,
  CircularProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  mr: { marginRight: theme.spacing(1.5) },
  gutter: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const LoadingSpinner = ({
  text,
  className,
  size,
  gutter = false,
  color,
}: {
  text?: string;
  className?: string;
  size?: number;
  gutter?: boolean;
  color?: string;
}) => {
  const classes = useStyles();
  return (
    <Box
      justifyContent="center"
      alignItems="center"
      display="flex"
      height="100%"
      className={clsx({ [className]: true, [classes.gutter]: gutter })}>
      {text && (
        <Typography variant="body1" className={classes.mr}>
          {text}
        </Typography>
      )}
      <CircularProgress
        size={size || 20}
        style={{
          color: color,
        }}
      />
    </Box>
  );
};

export default LoadingSpinner;
